import {makeStyles} from "@material-ui/core";

const withStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.primary.contrastText,
        minHeight: 'auto',
    },
    tabWrapper: {
        flexDirection: 'row',
    },
    tabRoot: {
        borderBottom: `2px solid ${theme.palette.text.disabled}`,
        fontFamily: 'NeoSansRegular',
        minHeight: 'auto',
        fontSize: '.83rem',
    },
    tabRootSelected: {
        color: theme.palette.primary.main,
    },
}));

export default withStyles;